import { Component, Inject, OnInit, TemplateRef, ViewChild } from '@angular/core';
import {
  ClusterInviteFragment,
  ClusterInvitesGQL,
  ClusterRevokeInvitationGQL,
  SendEmailInviteGQL,
} from "@/core/graphql/graphql";
import { filter, first, switchMap, tap } from 'rxjs/operators';
import {
  INVITES_COLUMNS,
} from "@/modules/clusters/components/cluster-details-modal/components/cluster-invites/cluster-invites.const";
import {
  ClusterInvitesDatasource,
} from "@/modules/clusters/components/cluster-details-modal/components/cluster-invites/cluster-invites.datasource";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ConfirmDialogComponent } from "@/shared/components/confirm-dialog/confirm-dialog.component";
import { ConfirmDialogModel } from "@/shared/components/confirm-dialog/confirm-dialog.model";
import { CosmosDialogService, CosmosDialogStyle } from "@/core/services/cosmos-dialog.service";
import { Column } from "@/shared/components/table/table.model";
import {
  ClusterSendEmailComponent,
} from "@/modules/clusters/components/cluster-details-modal/components/cluster-invites/modal/cluster-send-email/cluster-send-email.component";

@Component({
  selector: 'cosmos-cluster-invites',
  templateUrl: './cluster-invites.component.html',
  styleUrls: ['./cluster-invites.component.scss'],
})
export class ClusterInvitesComponent implements OnInit {
  public _columns: Column<ClusterInviteFragment>[] = [];
  public _dataSource: ClusterInvitesDatasource;
  @ViewChild('actions', { static: true }) private _actions: TemplateRef<any>;

  public constructor(
    private readonly _clusterInvitesGql: ClusterInvitesGQL,
    private readonly _clusterRevokeInvitationGql: ClusterRevokeInvitationGQL,
    private readonly _dialog: CosmosDialogService,
    private _addInviteService: SendEmailInviteGQL,
    @Inject(MAT_DIALOG_DATA) private readonly _data: { elementId: number },
  ) {
    this._dataSource = new ClusterInvitesDatasource(_clusterInvitesGql, this._data.elementId);
  }


  public ngOnInit(): void {
    this._columns = INVITES_COLUMNS(this._actions);
    this._dataSource.loadData();
  }

  public openSendEmailDialog(): void {
    const dialogRef = this._dialog.open<ClusterSendEmailComponent>(ClusterSendEmailComponent, {
      style: CosmosDialogStyle.Gray,
    });

    dialogRef.afterClosed().pipe(
      first(),
      filter(data => !!data),
      switchMap(email => this._addInviteService.mutate({
        clusterId: this._data.elementId,
        email: email,
      }),
      ),
      tap((_) => this._dataSource.loadData()),
    ).subscribe();
  }

  public removeInvitation(row: ClusterInviteFragment): void {
    const dialogRef = this._dialog.open<ConfirmDialogComponent, ConfirmDialogModel>(
      ConfirmDialogComponent,
      {
        data: {
          dialogMessage: `Would you like to revoke this invite (email: ${row.email})?`,
          confirmText: 'Confirm',
          cancelText: 'Cancel',
        },
        style: CosmosDialogStyle.Gray,
      });

    dialogRef.afterClosed().pipe(
      first(),
      filter(data => data),
      switchMap(() => this._clusterRevokeInvitationGql.mutate({
        clusterId: this._data.elementId,
        email: row.email,
      }),
      ),
      tap((_) => this._dataSource.loadData()),
    ).subscribe();
  }
}
